import { ClassOrString, Parameter, Verylys } from "./verylys";
import { Range } from './range.model';

export enum PRICING_METHOD {
    RANGE = "RANGE",
    STATIC = "STATIC"
}

export interface PriceList extends Verylys {
    _id: string;
    friendly_id: string;
    parameters: {
        quantity: Parameter<number>;
        pricing_method: Parameter<PRICING_METHOD>
    }

    ranges: Range[];
}